import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tComms\r\n\t\t\t\t")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("div", { class: "form-menu" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "float-end" })
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "input-group-btn" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, null, -1 /* HOISTED */);
const _hoisted_18 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_19 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_20 = { class: "float-end left5" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_23 = { class: "clearfix pad10" };
const _hoisted_24 = { class: "float-end" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_26 = {
    key: 0,
    class: "float-end"
};
const _hoisted_27 = { class: "float-end hidden-xs record-count" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12" };
const _hoisted_29 = { class: "card bg-white data-grid comms-grid detached overflow-x-auto" };
const _hoisted_30 = { class: "table table-hover bottom0 pw100" };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_33 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_34 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_35 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_36 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_37 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_38 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_39 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_40 = {
    key: 9,
    class: "hidden-sm"
};
const _hoisted_41 = {
    key: 10,
    class: "hidden-sm"
};
const _hoisted_42 = { key: 0 };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { class: "system-battery-type" };
const _hoisted_45 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_46 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_47 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_48 = { key: 0 };
const _hoisted_49 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_50 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_51 = { key: 0 };
const _hoisted_52 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_53 = { key: 0 };
const _hoisted_54 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_55 = {
    key: 8,
    class: "hidden-sm"
};
const _hoisted_56 = {
    key: 9,
    class: "hidden-sm"
};
const _hoisted_57 = {
    key: 10,
    class: "hidden-sm"
};
const _hoisted_58 = { key: 0 };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "9"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_60 = [
    _hoisted_59
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_8, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_10)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.companyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "Any company",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.siteId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                options: _ctx.filteredSites,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "Any site",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_multiselect, {
                                name: "system",
                                modelValue: _ctx.systemId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.systemId) = $event)),
                                options: _ctx.filteredSystems,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "Any system",
                                class: "multiselect-small",
                                disabled: _ctx.working
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _hoisted_17,
                _createTextVNode(),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_b_dropdown, {
                                    ref: "columnSettingsDropdown",
                                    "no-caret": "",
                                    end: "",
                                    sm: "",
                                    "auto-close": false,
                                    variant: "outline-secondary outline-secondary-pagination",
                                    disabled: _ctx.working
                                }, {
                                    "button-content": _withCtx(() => [
                                        _hoisted_21
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(),
                                        _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                            default: _withCtx(() => [
                                                _hoisted_22,
                                                _createTextVNode(),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                    return (_openBlock(), _createBlock(_component_b_form_group, {
                                                        key: column.fieldName
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_group, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_checkbox, {
                                                                        id: column.fieldName,
                                                                        modelValue: column.visible,
                                                                        "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createTextVNode(),
                                        _createVNode(_component_b_dropdown_divider),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createVNode(_component_b_button, {
                                                    variant: "secondary",
                                                    right: "",
                                                    sm: "",
                                                    onClick: _ctx.closeColumnSettingsMenu
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_25,
                                                        _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                            ]),
                            _createTextVNode(),
                            (_ctx.numberOfVisibleColumns)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_component_b_pagination, {
                                        class: "float-end",
                                        modelValue: _ctx.query.pageNo,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.pageNo) = $event)),
                                        "per-page": _ctx.query.pageSize,
                                        "total-rows": _ctx.data.recordCount,
                                        "hide-ellipsis": true,
                                        disabled: _ctx.working
                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_27, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("table", _hoisted_30, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('system'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SystemName', title: 'System' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('site'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_32, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SiteName', title: 'Site' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('company'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CompanyName', title: 'Company' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('lastComms'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_34, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenLastComms', title: 'Last Comms' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('lastCommsSourceId') && _ctx.isPowerShield)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_35, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'lastCommsSourceId', title: 'Last Comms Source' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('latestData'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenLastDataReceived', title: 'Latest Data' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('oldestData'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_37, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenFirstDataReceived', title: 'Oldest Data' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('monitor'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'MonitorFirmwareVersion', title: 'Monitor' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('modem'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_39, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'ModemFirmwareVersion', title: 'Modem' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('quality'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_40, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'CellularConnectionQuality', title: 'Quality' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('signal'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_41, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'LastSignalStrength', title: 'Signal' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        (_ctx.isVisible('system'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                                _createElementVNode("span", {
                                                    class: "pointer blue",
                                                    onClick: ($event) => (_ctx.goToSnapshot(item.systemId))
                                                }, [
                                                    _createTextVNode(_toDisplayString(item.systemName) + " ", 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getBatteryType(item.batteryTypeId)), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_43)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('site'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(item.siteName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('company'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(item.companyName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('lastComms'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                                (item.whenLastComms)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.getDateTimeFormatted(item.whenLastComms)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('lastCommsSourceId') && _ctx.isPowerShield)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_49, _toDisplayString(_ctx.getLastCommsSource(item.lastCommsSourceId)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('latestData'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                                (item.whenLastDataReceived)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.getDateTimeFormatted(item.whenLastDataReceived)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('oldestData'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                                                (item.whenFirstDataReceived)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.getDateTimeFormatted(item.whenFirstDataReceived)), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('monitor'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(item.monitorFirmwareVersion), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('modem'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(item.modemFirmwareVersion), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('quality'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(item.cellularConnectionQuality), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('signal'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(item.lastSignalStrength), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_58, _hoisted_60))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
